import { ReactNode } from "react";

export interface MetricItem {
  key: string;
  label: string;
  value: number;
  icon: ReactNode;
  color: string;
  onClick?: () => void;
  actionLabel?: string;
}

interface MetricsStripProps {
  items: MetricItem[];
}

const MetricsStrip = ({ items }: MetricsStripProps) => {
  return (
    <div className="flex flex-col rounded-xl border border-[#E4EAF0] bg-[#F0FAF9] sm:flex-row sm:divide-x sm:divide-[#E4EAF0] divide-y divide-[#E4EAF0] sm:divide-y-0">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={item.onClick}
          disabled={!item.onClick}
          className={`flex flex-1 flex-col items-center justify-center gap-2 px-4 py-4 text-center transition-colors ${
            item.onClick
              ? "hover:bg-white/70 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-400 cursor-pointer"
              : "cursor-default"
          }`}
          aria-label={`${item.label}: ${item.value}`}
        >
          <span
            className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider"
            style={{ color: item.color }}
          >
            <span aria-hidden="true" className="flex items-center">
              {item.icon}
            </span>
            {item.label}
          </span>
          <span className="text-[26px] font-extrabold leading-none text-[#10253A]">{item.value}</span>
        </button>
      ))}
    </div>
  );
};

export default MetricsStrip;